/**
       *********************************************************
       Description: Layout for the header component. Needs to be modified a little
       Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
       Another configuration is responsive can be added in the json to make the component responsive. When the screen size
       decreases all the header components that has isresponsive are show as a menu.
       limitations    : N/A
       *********************************************************
       **/
import { CssBaseline, Icon, List, ListItem, ListItemIcon, ListItemText, Popover, Tooltip } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import UserIcon from '@material-ui/icons/AccountCircle';
import SupportIcon from '@material-ui/icons/ContactSupport';
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationIcon from '@material-ui/icons/NotificationsActive';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import QuickLinks from '../../../../modules/dashboard/quicklinks';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { getProjectMessages, leftmenuDrawerOpen, moveSidebartoTop, setNotifications } from '../../../actions';
import { GetData, PostData, PutData } from '../../../controls/helpers/requests';
import { getSignInToken } from '../../../modules/header';
import { setProfile } from '../../../security/actions';
import SidebartabView from '../../sidebar/menutabs';
import SidebarMPStabView from '../../sidebar/menutabsMPS';
import Sidebar from '../../sidebar/sidebar';
import { getLandingPagelogo } from './ImageLogos';
import RightDrawer from './profilepopover';
import { createRequest, requestApi } from '../../../controls/helpers/rest';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import { Info } from '@material-ui/icons';
const _ = require('lodash');

// function getMenulistview() {
//     const value = localStorage.getItem('menulistview');
//     return value || 'Y';
//   }
//   const menulistview = getLocalStorageValue();
// console.log(menulistview);  // logs the value of 'menulistview' from localStorage


const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    grow: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'inline',
        // Removed display property
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'contents',
        },
        height: 'inherit',
    },
    sectionNonDesktop: {
        // display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'contents',
        },
        height: 'inherit',
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        height: 'inherit',
    },
});
const arr = localStorage.getItem('submodule') && JSON.parse(localStorage.getItem('submodule')) ? JSON.parse(localStorage.getItem('submodule')) : []

class MuiEdgeLayout extends Component {
    state = {
        anchorEl: null,
        mobileMoreAnchorEl: null,
        userProfile: {},
        landinglogo: '',
        moveSidebartoTop: 'N',
        rowClickedData: {},
    };


    componentDidMount() {
        this.loadInitialGrid();
        this.props.leftmenuDrawerOpen(localStorage.getItem('menulistview') && localStorage.getItem('menulistview') !== 'Y');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.profile) {
            let url = getEnvVariable('AccessPortal') === 'I' ? getEnvVariable('MasterAdmin') + `/api/${getEnvVariable('ModuleKey')}InternalUser/UserById/` : getEnvVariable('MasterAdmin') + `/api/ExternalUser/` + getEnvVariable('ModuleKey') + `/`;
            let user = localStorage.getItem('profile') && JSON.parse(localStorage.getItem('profile'))
            if (user.userId) {
                GetData(url + user.userId).then(res => {
                    this.props.setProfile(false)
                    this.setState({ userProfile: res })
                })
            }
        }
    }

    loadInitialGrid = () => {
        let logo = getLandingPagelogo();
        this.setState({ landinglogo: logo }, () => {
            let token = getSignInToken();
            let notificationCount = localStorage.getItem('notificationCount');
            if (token && !notificationCount) {
                this.props.setNotifications();
                const url = getEnvVariable('Report') + `/api/ReportQuery/DashboardNotifications`
                // const url= getEnvVariable('MasterAdmin') + `/api/CompanyInternal/RegistrationRequest/` + getEnvVariable('ModuleKey') + `/GetPending` +
                // `${localStorage.getItem('impersonate') ? '?impersonateFor=' + localStorage.getItem('impersonate') : ''}`
                this.fetchData('POST', url, null, null, true, true)
            }
        })
    }

    handleNavigation = (url) => {
        this.props.history.push(url)
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    handleNotificationClick = () => {
        this.props.history.push('/notifications')
    }

    //added for reload the page when we click on Home button
    handleHomeClick = () => {
        this.props.history.push('/')
        window.location.reload();
    }

    goToRegistrationRequest = (e) => {
        this.props.history.push('/Administration/registrationrequest');
    }

    handleTabClick = (each) => {
        this.props.history.push('/Records/' + each.key);
    }

    CSSBackgroundClasses = (style = '') => {
        let module = getEnvVariable('ModuleKey')
        switch (module) {
            case 'AEPS':
                return { background: 'linear-gradient(to right bottom, #ede7f6, #00355f)' }
            //return { background: 'linear-gradient(to right bottom, #ffffff , #00355f)' }//#ede7f6
            case 'WRS':
                return { background: 'linear-gradient(to right bottom,  #003349, #344032)' }
            // case 'AMES':
            //     return { background: 'linear-gradient(to right bottom,  rgb(12, 15, 26), rgb(41,51,82))' }
            case 'UPS':
                return { background: 'linear-gradient(to right bottom,  #004785, #337ab7)' }
            default:
                return { background: '#2b3a42' };
        }
    }

    CSSColorClasses = (style = '') => {
        let module = getEnvVariable('ModuleKey')
        switch (module) {
            case 'AEPS':
                return 'rgba(0, 53, 95, 255)'
            case 'AMES':
                return '#fff'
            default:
                return '';
        }
    }

    handleMenuMovetoTOp = (e) => {
        this.setState({ moveSidebartoTop: e }, () => {
            this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer)
            this.props.moveSidebartoTop(e)
        })
    }

    toggleDrawer = (e, val) => {
        this.setState({ open: val, anchorEl: val === false ? null : e.currentTarget })
    }

    selectedItmes = (event) => {
        this.setState({ selectedItems: event });
    }

    fetchData(requestType, url, queryParam, body, showAlert = true, registrationRequest = false) {
        const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
        if (requestType === "POST") {
            PostData(`${queryStr}`, body, showAlert)
                .then(response => {
                    //total count based on total records in grid for registration request grid
                    if (registrationRequest) {
                        let url = getEnvVariable('MasterAdmin') + `/api/CompanyInternal/RegistrationRequest/` + getEnvVariable('ModuleKey') + `/Grid`
                        GetData(url).then(res => {
                            if (res && res.total && res.data) {
                                this.setState({
                                    count: res.total,
                                    totalCount: res.data.filter(a => a.RequestStatus === "Pending").length,
                                });
                            }
                        })
                    }
                    else {
                        this.props.setNotifications(response.data);
                        if (response.value && response.value.data) {
                            this.setState({
                                //  count: finalarr,
                                //   totalCount: sum,
                            });
                        }
                    }

                })
        }

    }
    /**
        *********************************************************
        Description: Renders the header.
        Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
            Alignitem has left, right, title for aligning. Isresponsive property  puts the component inside the menu in the mobile screen.
            Alignitem drawer needs to be removed.
        limitations    : N/A
        *********************************************************
        **/

    render() {
        const { options, components, defaults, order, key, type, compmap, handleDrawerOpen, notification, headerTitle } = this.props;
        const { mobileMoreAnchorEl, anchorEl, count, totalCount, rowClickedData } = this.state;
        const { classes, theme } = this.props;
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        const { toolbaropt, menuopt, menuitemopt, iconbtnopt, position, ...otherOptions } = options
        let alignchildren = {
            left: [],
            right: [],
            title: [],
            drawer: [],
            isresponsive: [],
            isnotresponsive: [],
            inhead: []
        }
        components.forEach(each => {
            const { type, defaults, options } = each
            const { alignitem, isresponsive } = options
            const EachComp = compmap[each.type]
            const child = <EachComp {...each} key={each.key} compmap={compmap} />
            if (alignitem === 'left') {
                alignchildren.left.push(child)
                if (isresponsive === undefined) {
                    alignchildren.isnotresponsive.push(child)
                }
            }
            if (alignitem === 'right') {
                alignchildren.right.push(child)
                if (isresponsive === undefined) {
                    alignchildren.isresponsive.push(child)
                }
            }
            if (alignitem === 'title') {
                alignchildren.title.push(child)
                if (isresponsive === undefined) {
                    alignchildren.inhead.push(child)
                }
            }
            if (alignitem === 'drawer') {
                alignchildren.drawer.push(child)
                if (isresponsive === undefined) {
                    alignchildren.inhead.push(child)
                }
            }
            if (isresponsive) {
                alignchildren.isresponsive.push(child)
            }
            else {
                if (isresponsive === false) {
                    alignchildren.isnotresponsive.push(child)
                }
            }
        })

        /**
       *********************************************************
       Description: Handles rendering the header for the mobiles.
       Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
           Another configuration is responsive can be added in the json to make the component responsive. When the screen size
           decreases all the header components that has isresponsive are pushed into a menu on button.
       limitations    : N/A
       *********************************************************
       **/
        const isMenuOpen = Boolean(anchorEl);



        const renderMobileMenu = (
            <>
                <Menu
                    anchorEl={mobileMoreAnchorEl}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={isMobileMenuOpen}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem disabled>
                        <IconButton >
                            <UserIcon />
                        </IconButton>
                        {(this.props.accessPermissions && this.props.accessPermissions.name)}
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => window.open(getEnvVariable('HelpUI'))}>
                        <IconButton color="inherit">
                            <SupportIcon />
                        </IconButton>
                        <p> Help</p>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => this.handleNavigation('/notifications')}>
                        <IconButton color="inherit">
                            <Badge max="9999" badgeContent={(notification && (notification === 0 ? '0' : notification)) || '0'} color="secondary">
                                <NotificationIcon />
                            </Badge>
                        </IconButton>
                        <p>&nbsp;Notifications</p>
                    </MenuItem>
                    {/* <QuickLinks showMenuList={true} /> */}
                    <Divider />
                    <MenuItem onClick={(e) => this.toggleDrawer(e, true)}>
                        <Badge badgeContent={totalCount && !(_.isNaN(totalCount)) ? totalCount.toString() : '0'} max={1000000000000}
                            color="error">
                            <HowToVoteIcon color='primary' />
                        </Badge>
                        <p>&nbsp;Pending Registrations Request</p>
                    </MenuItem>
                    <Divider />
                    <RightDrawer accessPermissions={this.props.accessPermissions} mobile={true} compmap={this.props.compmap} userProfile={this.state.userProfile || null} />
                </Menu>
            </>
        );

        return (
            <div className={classes.grow}>
                <CssBaseline />
                <AppBar position={localStorage.getItem('menulistview') === 'Y' ? position : "fixed"} {...otherOptions} className={classes.appBar}
                    elevation={0}>
                    <Toolbar variant="dense" {...toolbaropt} className={getEnvVariable("AccessPortal") === 'E' && !this.props.user ? classes.toolbar : {}}>
                        <div className={this.props.accessPermissions ? classes.sectionDesktop : classes.sectionNonDesktop} >
                            {this.props.user && <>   <img alt='' src={getLandingPagelogo() || ''} className="d-inline-block" width='auto' height='20px' />
                                {(localStorage.getItem('menulistview') ? localStorage.getItem('menulistview') !== 'Y' : this.state.moveSidebartoTop === 'N') &&
                                    // <IconButton style={{ marginLeft: 75 }} color='primary' size='small'>
                                    <IconButton style={{ marginLeft: 75, backgroundColor: '#ede7f6' }} elevation={0} color='primary' size='small' onClick={() => { this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer) }}> <MenuIcon color='primary' /></IconButton>
                                    // </IconButton>
                                }
                            </>
                            }
                            {!this.props.user && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img alt='' src={this.state.landinglogo || ''} className="d-inline-block" width='auto' height='80px' style={{ padding: '5px', marginTop: 15, marginBottom: 5 }} />
                                        <div className='mx-3' />
                                        <div>
                                            <Typography color='primary' className='pt-3' variant='h4'>{getEnvVariable('Title')}</Typography>
                                            <Typography color='secondary' variant='caption'>{getEnvVariable('SubTitle')}</Typography>
                                        </div>
                                    </div>
                                    {getEnvVariable('AccessPortal') === 'E' && <> <Typography
                                        style={{ marginLeft: 'auto', color: '#B71C1C', fontWeight: 600 }}
                                        variant='subtitle2' component='p' aria-label='Important account notice'
                                    >
                                        <Info style={{ fontSize: 'small', verticalAlign: 'middle', marginRight: 4 }} /> If you already have permits with DOTD, please do not create a new account. <br /> &nbsp; &nbsp; Instead, contact DOTD to activate your existing account.
                                    </Typography></>}
                                </div>
                            )
                            }
                            {alignchildren.left}
                            <div style={{ flexGrow: 1 }} />
                            <div />
                            {alignchildren.right}
                            {this.props.user && <Fragment>
                                <Fab disableElevation elevation={0} style={{ backgroundColor: '#ede7f6', marginBottom: '10px' }} size='small' className="m-1" title="Home" onClick={e => this.handleHomeClick(e)}>
                                    <HomeIcon color='primary' />
                                </Fab>
                                <Fab disableElevation elevation={0} title="Help" className=" mx-1" size='small' href={getEnvVariable('HelpUI')} target='_blank' style={{ backgroundColor: '#e8eaf6' }}>
                                    <SupportIcon color='secondary' />
                                </Fab>
                                <Fab disableElevation elevation={0} style={{ backgroundColor: '#ede7f6' }} size='small' title="Unread Notifications" className=" mx-1" onClick={e => this.handleNotificationClick(e)}>
                                    <Badge max="9999" badgeContent={(notification && (notification === 0 ? '0' : notification)) || localStorage.getItem('notificationCount') || '0'} color='secondary'>
                                        <NotificationIcon color='primary' />
                                    </Badge>
                                </Fab>

                                {getEnvVariable("AccessPortal") !== 'E' && (this.props.accessPermissions.isRequestAdmin === 'Y') &&
                                    <Fab disableElevation elevation={0} style={{ backgroundColor: '#e8eaf6' }} size='small' title="Pending Registration Request" className=" mx-1" onClick={(e) => this.goToRegistrationRequest(e, true)}>
                                        <Badge badgeContent={totalCount && !(_.isNaN(totalCount)) ? totalCount.toString() : '0'} max={1000000000000}
                                            color="error">
                                            <HowToVoteIcon color='primary' />
                                        </Badge>
                                    </Fab>
                                }

                                <Popover
                                    id="simple-popover"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={(e) => this.toggleDrawer(e, false)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >

                                    <List>
                                        {/* {count && arr.map((each, index) => {
                                                   return <Tooltip title={each.title ? each.title : each.DisplayName} key={index} >
                                                       <ListItem button onClick={() => this.handleTabClick(each)} color='primary'>
                                                           <ListItemIcon>
                                                               <Icon style={{ color: each.color }}>{each.materialicon}</Icon>
                                                           </ListItemIcon>
                                                           <ListItemText primary={each.title ? each.title : each.DisplayName} />
                                                           <ListItemText primary={': ' + count[each.key]} />
                                                       </ListItem>
                                                   </Tooltip>
                                               })
                                               } */}
                                        {/* <Divider color='primary' />
                                               <ListItem button onClick={(e) => this.goToRegistrationRequest(e)}>
                                                   <ListItemIcon>
                                                       <Icon color='primary'>how_to_vote</Icon>
                                                       <ListItemText primary={'Go to Registration Request'} />
                                                   </ListItemIcon>
                                               </ListItem> */}
                                    </List>
                                </Popover>


                                {/* <QuickLinks /> */}
                                <RightDrawer accessPermissions={this.props.accessPermissions} compmap={compmap} userProfile={this.state.userProfile || null}
                                    handlefieldchange={(e) => this.handleMenuMovetoTOp(e)} mobile={true}
                                    handleNotificationClick={this.handleNotificationClick} />
                            </Fragment>
                            }
                        </div>
                        {this.props.accessPermissions && <div className={classes.sectionMobile}>
                            {/* {alignchildren.inhead}
                                                 <div /> */}
                            <img alt='' src={getLandingPagelogo() || ''} className="d-inline-block mt-2 me-3" width='auto' height='20px' />
                            {this.props.user && (localStorage.getItem('menulistview') ? localStorage.getItem('menulistview') !== 'Y' : this.state.moveSidebartoTop === 'N') && <>
                                <Fab className='float-end' style={{ marginLeft: 20, marginTop: 5, backgroundColor: '#ede7f6' }} color='primary' size='small' onClick={() => { this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer) }}>
                                    <MenuIcon color='primary' />
                                </Fab></>}
                            {this.props.user && <>
                                <Fab disableElevation elevation={0} style={{ backgroundColor: '#ede7f6' }} size='small' className="m-1" title="Home" onClick={() => this.props.history.push('/')}>
                                    <HomeIcon color='primary' />
                                </Fab>
                                {/* <QuickLinks isMobile={true} /> */}
                            </>}
                            <RightDrawer accessPermissions={this.props.accessPermissions} compmap={compmap} userProfile={this.state.userProfile || null}
                                handlefieldchange={(e) => this.handleMenuMovetoTOp(e)} mobile={true}
                                handleNotificationClick={this.handleNotificationClick}
                            />
                        </div>}
                    </Toolbar>
                    {this.props.user && this.props.parentcomponents && this.props.parentcomponents.find(each => each.type === 'drawer') &&
                        < Sidebar  {...this.props.parentcomponents.find(each => each.type === 'drawer')} key={(this.props.components.find(each => each.type === 'drawer') || {}).key}
                            AccessPortal={getEnvVariable('AccessPortal')} compmap={compmap} accessPermissions={this.props.accessPermissions}
                            accessLevelPermissions={this.props.accessLevelPermissions} openSidebarDisplay={this.state.openSidebarDisplay} />
                    }
                    {this.props.accessPermissions && renderMobileMenu}
                </AppBar>
                {(this.props.user && ((this.props.isTabView && this.props.isTabView === 'Y') || localStorage.getItem('menulistview') === 'Y')) &&
                    getEnvVariable('ModuleKey') === 'MPS' ? <SidebarMPStabView /> :
                    <SidebartabView />
                }
            </div >
        )

    }

}

MuiEdgeLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};
MuiEdgeLayout = withStyles(styles)(MuiEdgeLayout);
const mapProps = (state) => {
    return {
        user: state.authentication.user, profile: state.authentication.profile,
        leftmenuDrawer: (state.header && state.header.leftmenuDrawer ? state.header.leftmenuDrawer : false),
        isTabView: (state.header && state.header.movebartoTop ? state.header.movebartoTop : false),
        notification: (state.header && state.header.notifications) || 0,
        totalCount: (state.header && state.header.totalCount) || 0,
        // notification2: (state.header && state.header.notifications) || 0
    }
}
const mapActions = dispatch => {
    return bindActionCreators({ setNotifications, getProjectMessages, setProfile, leftmenuDrawerOpen, moveSidebartoTop }, dispatch);
}

MuiEdgeLayout = connect(mapProps, mapActions)(MuiEdgeLayout);
export default withRouter(MuiEdgeLayout);